"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableHeaderCellLabelWrapper = void 0;
var _TableHeaderCellLabelWrapper = require("./TableHeaderCellLabelWrapper");
// TODO: in v9, move styled() from TableHeaderCellLabelWrapper.jsx to here
var StyledTableHeaderCellLabelWrapper = _TableHeaderCellLabelWrapper.TableHeaderCellLabelWrapper;
exports.StyledTableHeaderCellLabelWrapper = StyledTableHeaderCellLabelWrapper;